import { NgModule } from "@angular/core";
import { ContactAddSuccessComponent } from "./contact-add-success/contact-add-success.component";
import { ContactAddressListItemComponent } from "./contact-address-list-item/contact-address-list-item.component";
import { ContactEditComponent } from "./contact-edit-modal/contact-edit.component";
import { ContactListComponent } from "./contact-list/contact-list.component";
import { ContactListItemComponent } from "./contact-list-item/contact-list-item.component";
import { ContactViewComponent } from "./contact-view-modal/contact-view.component";
import { CoreModule } from "../../../core/core.module";
import { FilterModule } from "../filters/filter.module";
import { ContactAddressSelectComponent } from "./contact-address-select/contact-address-select.component";

const components = [
	ContactAddSuccessComponent,
	ContactAddressListItemComponent,
	ContactEditComponent,
	ContactListComponent,
	ContactListItemComponent,
	ContactViewComponent,
	ContactAddressSelectComponent
];

@NgModule({
	imports: [CoreModule, FilterModule],
	declarations: [...components],
	exports: [...components]
})
export class ContactModule {}
